import React, { createContext, useContext, useEffect, useState } from 'react';
import { YouTubeLiveStream } from '../types/youtube';
import { checkForLiveStream } from '../services/youtubeService';

interface LiveStreamContextValue {
  liveStream: YouTubeLiveStream | null;
  isChecked: boolean;
}

const LiveStreamContext = createContext<LiveStreamContextValue>({
  liveStream: null,
  isChecked: false,
});

const POLL_INTERVAL_MS = 5 * 60 * 1000;

export const LiveStreamProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [liveStream, setLiveStream] = useState<YouTubeLiveStream | null>(null);
  const [isChecked, setIsChecked] = useState(false);

  useEffect(() => {
    let isMounted = true;

    const check = async () => {
      if (document.visibilityState === 'hidden') {
        return;
      }

      const live = await checkForLiveStream();
      if (isMounted) {
        setLiveStream(live);
        setIsChecked(true);
      }
    };

    check();

    const interval = setInterval(check, POLL_INTERVAL_MS);
    const onVisibilityChange = () => {
      if (document.visibilityState === 'visible') {
        check();
      }
    };

    document.addEventListener('visibilitychange', onVisibilityChange);

    return () => {
      isMounted = false;
      clearInterval(interval);
      document.removeEventListener('visibilitychange', onVisibilityChange);
    };
  }, []);

  return (
    <LiveStreamContext.Provider value={{ liveStream, isChecked }}>
      {children}
    </LiveStreamContext.Provider>
  );
};

export const useLiveStream = () => useContext(LiveStreamContext);
